import React, { useState } from 'react';
import { ChevronRightIcon, ChevronDownIcon } from '@heroicons/react/20/solid';

const JSONViewer = ({ data }) => {
    const [expanded, setExpanded] = useState({});

    const toggleExpand = (path) => {
        setExpanded(prev => ({
            ...prev,
            [path]: !prev[path]
        }));
    };

    const renderValue = (value, path = '') => {
        if (value === null) return <span className="text-gray-500">null</span>;
        if (typeof value === 'boolean') return <span className="text-purple-600">{value.toString()}</span>;
        if (typeof value === 'number') return <span className="text-blue-600">{value}</span>;
        if (typeof value === 'string') return <span className="text-green-600">"{value}"</span>;
        
        const isArray = Array.isArray(value);
        const isExpanded = expanded[path];
        
        if (isArray || typeof value === 'object') {
            const items = isArray ? value : Object.entries(value);
            return (
                <div className="ml-4">
                    <div 
                        className="flex items-center cursor-pointer hover:bg-gray-50 py-1"
                        onClick={() => toggleExpand(path)}
                    >
                        {isExpanded ? (
                            <ChevronDownIcon className="h-4 w-4 text-gray-500" />
                        ) : (
                            <ChevronRightIcon className="h-4 w-4 text-gray-500" />
                        )}
                        <span className="text-gray-700">
                            {isArray ? '[' : '{'}
                            {!isExpanded && (
                                <span className="text-gray-400">
                                    {isArray ? `${items.length} items` : `${Object.keys(value).length} keys`}
                                </span>
                            )}
                            {!isExpanded && (isArray ? ']' : '}')}
                        </span>
                    </div>
                    
                    {isExpanded && (
                        <div className="ml-4 border-l border-gray-200">
                            {isArray ? (
                                items.map((item, index) => (
                                    <div key={index} className="flex items-start py-1">
                                        <span className="text-gray-500 mr-2">{index}:</span>
                                        {renderValue(item, `${path}.${index}`)}
                                    </div>
                                ))
                            ) : (
                                Object.entries(value).map(([key, val], index) => (
                                    <div key={key} className="flex items-start py-1">
                                        <span className="text-gray-800 font-medium mr-2">{key}:</span>
                                        {renderValue(val, `${path}.${key}`)}
                                    </div>
                                ))
                            )}
                            <div className="ml-[-1rem]">
                                <span className="text-gray-700">{isArray ? ']' : '}'}</span>
                            </div>
                        </div>
                    )}
                </div>
            );
        }
        
        return <span>{String(value)}</span>;
    };

    return (
        <div className="font-mono text-sm bg-white rounded-lg p-4">
            {renderValue(data, 'root')}
        </div>
    );
};

export default JSONViewer; 